import React, { useContext } from 'react';
import { Container, useMediaQuery } from '@material-ui/core';
import DehazeIcon from '@material-ui/icons/Dehaze';
import NavLink from '../Navlink/Navlink.component';
import Routes from '../../modules/Navigator/Navigator.route';
import UserMenu from '../UserMenu/UserMenu.component';
import { parseJSON } from 'src/utils/common.util';
import MainLogo from '../MainLogo/MainLogo';
import RightModal from 'src/components/RightModal/RightModal';
import { AppContext } from 'src/context/AppContextProvider';
import { useCookies } from 'react-cookie';
import { APP_CONSTANT } from 'src/constants';
import { getOnlineBookingFormStatus } from 'src/services/onlineAppointmentBooking.service';

interface IProps {
  cookies: {
    userInfo: {
      name: { nameFirst: string; nameLast: string };
    };
    role: string;
  };
}

const NavBar: React.FC<IProps> = ({ cookies }) => {
  const context = useContext(AppContext);
  const matches = useMediaQuery('(max-width:768px)');
  const isIpadLg = useMediaQuery('(max-width:1024px)');
  const isTablet = matches || isIpadLg;

  const [isOpenNavbar, setIsOpenNavbar] = React.useState<boolean>(false);
  const [cookie] = useCookies([]);

  const closeDrawer = () => {
    setIsOpenNavbar(false);
  };

  const isLoggedIn = [
    APP_CONSTANT.ROLE_SINGLE_USER,
    APP_CONSTANT.ROLE_LEGAL_GUARDIAN
  ].includes(cookie.role);

  const handleOpenNavbar = () => setIsOpenNavbar(true);

  React.useEffect(() => {
    getOnlineBookingFormStatus(isLoggedIn).then((response) => {
      context.changeIsPublish(response.isOnlineBookingEnabled);
    });
  }, []);

  return (
    <div className="navbar navbar__wrapper">
      <Container>
        <MainLogo logoPath={(parseJSON('tenantInfo') as any).logoPath} />
        {isTablet ? (
          <DehazeIcon onClick={handleOpenNavbar} />
        ) : (
          <>
            <div className="navbar__navlink-group">
              {(context.isOABFormPublished || isLoggedIn) && (
                <NavLink
                  to={Routes.Dashboard}
                  title={'Dashboard'}
                  className="mr-30"
                />
              )}
              <NavLink
                to={Routes.PatientDocument}
                title={'Patient Documents'}
                className="mr-30"
              />
            </div>
            <UserMenu cookies={cookies} />
          </>
        )}
      </Container>
      {isTablet && (
        <RightModal
          open={isOpenNavbar}
          closeDrawer={closeDrawer}
          cookies={cookies}
        />
      )}
    </div>
  );
};

export default NavBar;
